import React from "react";

if (
  typeof document !== "undefined" &&
  !document.getElementById("policy-shimmer-keyframes")
) {
  const styleEl = document.createElement("style");
  styleEl.id = "policy-shimmer-keyframes";
  styleEl.textContent =
    "@keyframes policyShimmer { 100% { transform: translateX(100%); } }";
  document.head.appendChild(styleEl);
}

const Shimmer = ({ className = "", style, ...rest }) => (
  <div
    className={`relative overflow-hidden bg-[#E5E9EB] rounded-md before:absolute before:inset-0 before:-translate-x-full before:animate-[policyShimmer_1.4s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/70 before:to-transparent ${className}`}
    style={style}
    aria-hidden="true"
    {...rest}
  />
);

export default Shimmer;
